import { useDoctorOnboardingStatus, useSubmitDoctorKyc } from '@api/queries';
import OnboardingTabs from '@components/kyc/OnboardingTabs';

/* The doctor's in-portal onboarding: Documents + Details tabs, wired to the
   doctor endpoints. */
export default function DoctorDocuments() {
  const statusQuery = useDoctorOnboardingStatus();
  const submit = useSubmitDoctorKyc();
  return <OnboardingTabs kind="doctor" statusQuery={statusQuery} submit={submit} homePath="/doctor" />;
}
